import React from "react";
import logo from "../../assets/images/osi_logo.png";
import { Grid } from "antd";

// Approved OSI logo asset — never redraw, stretch, rotate or add effects.
// Intrinsic size is 1000x474; `mobile` only selects the smaller CSS size.
export const Logo = ({
  mobile,
  onClick,
}: {
  mobile?: boolean;
  onClick?: () => void;
}) => {
  const { useBreakpoint } = Grid;
  const { xs } = useBreakpoint();
  const small = xs || mobile;
  return (
    <img
      src={logo}
      alt="OSI Support"
      width={1000}
      height={474}
      className={small ? "logo-img-mobile" : "logo-img"}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : undefined }}
    />
  );
};
